import { Component, effect, inject, signal, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LicenseManager } from 'ag-grid-enterprise';
import { UnityCoreAppConfigService } from '@unity/core-services-lib';
import { CookieConsentComponent } from '@unity/core-login-lib';
import { MainRouterOutletComponent } from '@unity/core-components-lib';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CookieConsentComponent, MainRouterOutletComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  darkTheme = signal(false);
  private appConfigService: UnityCoreAppConfigService;


  constructor() {
    this.appConfigService = inject(UnityCoreAppConfigService);
    this.configureAgGridLicense();

    
    effect(() => {
      document.body.classList.toggle('dark', this.darkTheme());
      document.body.classList.toggle('light', !this.darkTheme());
    });

    effect(() => {
      // remove density-* classes
      document.body.classList.forEach((className) => {
        if (className.startsWith('density-')) {
          document.body.classList.remove(className);
        }
      });
    });
  }

  configureAgGridLicense() { //TODO move this to startup
    LicenseManager.setLicenseKey(this.appConfigService.agGridLicenseKey);
  }
}